import {AuthApi} from "@/Stub/V1";
import {BaseApiConfig} from "@/Service/Api/V1/BaseApiConfig";

export const AuthApiClient = new AuthApi(BaseApiConfig);